import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d54529b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "user-statistics"
}

import { ComputedRef, Ref, computed, ref, toRefs, watch } from 'vue'
  import { useI18n } from 'vue-i18n'

  import StatChart from '@/components/Common/StatsChart/index.vue'
  import StatsMenu from '@/components/Statistics/StatsMenu.vue'
  import SportsMenu from '@/components/Statistics/StatsSportsMenu.vue'
  import { ISport, ITranslatedSport } from '@/types/sports'
  import { IStatisticsDateParams } from '@/types/statistics'
  import { IUserProfile } from '@/types/user'
  import { translateSports } from '@/utils/sports'
  import { getStatsDateParams, updateChartParams } from '@/utils/statistics'

  interface Props {
    sports: ISport[]
    user: IUserProfile
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    sports: null,
    user: null
  },
  setup(__props: any) {

const props = __props as {
    sports: ISport[]
    user: IUserProfile
  }

  

  const { t } = useI18n()

  const { sports, user } = toRefs(props)
  let selectedTimeFrame = ref('month')
  const chartParams: Ref<IStatisticsDateParams> = ref(
    getChartParams(selectedTimeFrame.value)
  )
  const translatedSports: ComputedRef<ITranslatedSport[]> = computed(() =>
    translateSports(props.sports, t)
  )
  const selectedSportIds: Ref<number[]> = ref(getSports(props.sports))

  function updateTimeFrame(timeFrame: string) {
    selectedTimeFrame.value = timeFrame
    chartParams.value = getChartParams(selectedTimeFrame.value)
  }
  function getChartParams(timeFrame: string): IStatisticsDateParams {
    return getStatsDateParams(new Date(), timeFrame, props.user.weekm)
  }
  function handleOnClickArrows(backward: boolean) {
    chartParams.value = updateChartParams(
      chartParams.value,
      backward,
      props.user.weekm
    )
  }
  function getSports(sports: ISport[]) {
    return sports.map((sport) => sport.id)
  }
  function updateSelectedSportIds(sportId: number) {
    if (selectedSportIds.value.includes(sportId)) {
      selectedSportIds.value = selectedSportIds.value.filter(
        (id) => id !== sportId
      )
    } else {
      selectedSportIds.value.push(sportId)
    }
  }

  watch(
    () => props.sports,
    (newSports) => {
      selectedSportIds.value = getSports(newSports)
    }
  )

return (_ctx: any,_cache: any) => {
  return (_unref(translatedSports))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(StatsMenu, {
          onTimeFrameUpdate: updateTimeFrame,
          onArrowClick: handleOnClickArrows
        }),
        _createVNode(StatChart, {
          sports: _unref(sports),
          user: _unref(user),
          chartParams: chartParams.value,
          "displayed-sport-ids": selectedSportIds.value,
          fullStats: true
        }, null, 8, ["sports", "user", "chartParams", "displayed-sport-ids"]),
        _createVNode(SportsMenu, {
          "selected-sport-ids": selectedSportIds.value,
          "user-sports": _unref(sports),
          onSelectedSportIdsUpdate: updateSelectedSportIds
        }, null, 8, ["selected-sport-ids", "user-sports"])
      ]))
    : _createCommentVNode("", true)
}
}

})